import { render, staticRenderFns } from "./Form03_142.vue?vue&type=template&id=b01871fc&scoped=true&"
import script from "./Form03_142.vue?vue&type=script&lang=js&"
export * from "./Form03_142.vue?vue&type=script&lang=js&"
import style0 from "./Form03_142.vue?vue&type=style&index=0&id=b01871fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01871fc",
  null
  
)

export default component.exports